module.exports = __webpack_public_path__ + "img/download_txt.f7676520.png";